import { api } from "../Configurations/axios";

//Post
const CreateProjectAPI = async (companyId: string, opportunityId: string,
    userEmail: string, projectName: string, activities: string, startDate: string,
    endDate: string, type: number, budget: string, rhValues: string, equipmentValues: string,
    invoiceValues: string, infraValues: string, contractTypeText: string, inProgress: boolean,
    objective: string, contractCET: boolean, expectedExpenses: string, valuesApplied: boolean,
    others: string
) => {
    try {
        
        const result = await api.post('/Project/CreateProject', {
            companyId: companyId,
            opportunityId: opportunityId,
            userEmail: userEmail,
            projectName: projectName,
            activities: activities,
            startDate: startDate,
            endDate: endDate,
            type: type,
            budget: parseFloat(budget),
            rhValues: parseFloat(rhValues),
            equipmentValues: parseFloat(equipmentValues),
            invoiceValues: parseFloat(invoiceValues),
            infraValues: parseFloat(infraValues),
            contractType: contractTypeText,
            inProgress: inProgress,
            objective: objective,
            contractCET: contractCET,
            expectedExpenses: expectedExpenses,
            valuesApplied: valuesApplied,
            others: parseFloat(others)
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const CreateCopiedAPI = async (projectIds: string, opportunityId: string, companyId: string, userEmail: string) => {
    try {
        const result = await api.post('/Project/CreateCopied', {
            projectIds,
            opportunityId,
            companyId,
            userEmail
        });
        return result.data;
    } catch (error: any) {

        throw new Error(error.response ? error.response.data : error.message);
    }
}

//PUT
const EditProjectAPI = async (projectId: string, userEmail: string,
    projectName: string, activities: string, startDate: string,
    endDate: string, budget: string, rhValues: string, equipmentValues: string,
    invoiceValues: string, infraValues: string, eligibleText: string, companyId: string,
    contractTypeText: string, inProgress: boolean, objective: string, contractCET: boolean,
    expectedExpenses: string, valuesApplied: boolean, othersValue?: string | null) => {
    try {
        const result = await api.put('/Project/EditProject', {
            projectId: projectId,
            userEmail: userEmail,
            projectName: projectName,
            activities: activities,
            startDate: startDate,
            endDate: endDate,
            budget: parseFloat(budget) || 0,
            rhValues: parseFloat(rhValues) || 0,
            equipmentValues: parseFloat(equipmentValues) || 0,
            invoiceValues: parseFloat(invoiceValues) || 0,
            infraValues: parseFloat(infraValues) || 0,
            eligible: eligibleText,
            companyId: companyId,
            contractType: contractTypeText,
            inProgress: inProgress,
            objective: objective,
            contractCET: contractCET,
            expectedExpenses: expectedExpenses,
            valuesApplied: valuesApplied,
            others: othersValue != null && othersValue !== '' ? parseFloat(othersValue) : null
        });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const PutJustificationOnProjectAPI = async (projectId: string, justification: string, userEmail: string, companyId: string) => {
    try {
        const result = await api.put('/Project/AddJustificationOnProject', { projectId: projectId, justification: justification, userEmail: userEmail, companyId: companyId });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

//GET
const GetAllProjectsAPI = async (opportunityId: string, type: number, page: number, take: number, word: string) => {
    try {
        word = word === "" ? "all" : word;
        const result = await api.get(`/Project/GetAllProjectsByType/?opportunityId=${opportunityId}&type=${type}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const GetAllProjectByOpportunity = async (opportunityId: string) => {
    try {
        const result = await api.get(`/Project/GetAllProjectWithGroupingAndPainel/${opportunityId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
const getAllProjectsByCompanyAndYear = async (companyId: string, year: string, page: number, take: number) => {
    try {
        const result = await api.get(`/Project/GetAllProjectsLastYear/?companyId=${companyId}&year=${year}&page=${page}&take=${take}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetAllFutureProjectsAPI = async (companyId: string, year: number, page: number, take: number, word: string) => {
    try {
        word = word === "" ? "all" : word;
        const result = await api.get(`/Project/GetAllFutureProjectsByYear/?companyId=${companyId}&year=${year}&page=${page}&take=${take}&word=${encodeURIComponent(word)}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetProjectAPI = async (projectId: string) => {
    try {
        const result = await api.get(`/Project/GetProject/?projectId=${projectId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const GetProjectsOpportunityPanelsByOpportunityAPI = async (opportunityId: string) => {
    try {
        const result = await api.get(`/Project/GetAllProjectWithGroupingAndPainel/${opportunityId}`);
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

//Delete
const DeleteProjectAPI = async (projectId: string, opportunityId: string, companyId: string) => {
    try {
        const result = await api.delete('/Project/DeleteProject', { data: { projectId: projectId, opportunityId: opportunityId, companyId: companyId } });
        const response = await result.data;
        return response;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}
//, contractTypeText: string
const handleUploadProjectAPI = async (file: Blob, companyId: string, opportunityId: string, userEmail: string, type: number, inProgress: boolean) => {
    try {
        var UploadProjectFileCommand = new FormData()

        UploadProjectFileCommand.append('file', file);
        UploadProjectFileCommand.append('companyId', companyId);
        UploadProjectFileCommand.append('opportunityId', opportunityId);
        UploadProjectFileCommand.append('userEmail', userEmail);
        UploadProjectFileCommand.append('type', type.toString());
        UploadProjectFileCommand.append('inProgress', inProgress.toString());
        // UploadProjectFileCommand.append('contractType',contractTypeText);

        //&contractTypeText=${contractTypeText}&userEmail=${encodeURIComponent(userEmail)}&OportunityId=${opportunityId}&ProjectType=${type}&InProgress=${inProgress}
        const result = await api.post(`/Project/UploadExcel`, UploadProjectFileCommand, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }

        });
        const dataFiles = await result.data;
        return dataFiles;
    } catch (error: any) {
        throw new Error(error.response.data);
    }
}

const handleDownloadProjectModelAPI = async () => {
    try {

        const result = await api.get(`Project/DownloadModel`, {
            responseType: 'blob'
        });
        const response = await result.data;
        return response;
    }
    catch (error: any) {
        throw new Error(error.response.data);
    }
}




export {
    CreateProjectAPI,
    CreateCopiedAPI,
    EditProjectAPI,
    PutJustificationOnProjectAPI,
    GetAllProjectsAPI,
    getAllProjectsByCompanyAndYear,
    GetAllFutureProjectsAPI,
    GetProjectAPI,
    GetProjectsOpportunityPanelsByOpportunityAPI,
    DeleteProjectAPI,
    handleUploadProjectAPI,
    handleDownloadProjectModelAPI,
    GetAllProjectByOpportunity

}